import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined"
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined"
import { CircularProgress, IconButton } from "@mui/material"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { useEffect, useState } from "react"
import MainLayout from "../../layouts/MainLayout"
import api from "../../services"
import { phoneMask } from "../../utils/masks"
import ModalCheck from "./components/modal"
import * as S from "./style"

function Home() {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [data, setData] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [paramsName, setParamsName] = useState({ name: "" })
  const [paramsEmail, setParamsEmail] = useState({ email: "" })

  const [body, setBody] = useState({
    type: "",
    content: "",
  })

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  function openModalCheck(row) {
    setData(row)
    setModalIsOpen(true)
    setAnchorEl(null)
  }

  async function getData() {
    if (body.type === "name") {
      setParamsName({
        name: body.content,
      })
    } else if (body.type === "email") {
      setParamsEmail({
        email: body.content,
      })
    }

    try {
      setLoading(true)
      const res = await api.get(
        "/api/admin/users/list",
        body.type === "name" ? { params: paramsName } : { params: paramsEmail }
      )
      setUsers(res.data)
      setLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <MainLayout title="Cadastro de usuários do App">
      <S.Header>
        <S.Select onChange={(e) => setBody({ ...body, type: e.target.value })}>
          <option value="" selected>
            Selecionar filtro
          </option>
          <option value="name">Nome</option>
          <option value="email">Email</option>
        </S.Select>
        <S.Input
          placeholder="Busque pelo nome"
          onChange={(e) => setBody({ ...body, content: e.target.value })}
        />
        <S.Button disabled={loading} onClick={() => getData()}>
          Pesquisar
        </S.Button>
      </S.Header>

      <TableContainer component={Paper}>
        {loading ? (
          <S.ContainerLoading>
            <CircularProgress style={{ color: "#919DF2" }} />
          </S.ContainerLoading>
        ) : (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead sx={{ backgroundColor: "#B2B2B2" }}>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Telefone</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {users?.map((item) => (
                <TableRow
                  key={item.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="item">
                    {item?.name ? item?.name : "-"}
                  </TableCell>
                  <TableCell>{item?.email ? item?.email : "-"}</TableCell>
                  <TableCell>
                    {item?.telefone ? phoneMask(item?.telefone) : "-"}
                  </TableCell>
                  <TableCell onClick={() => openModalCheck(item)}>
                    <IconButton
                      aria-label="more"
                      id="long-button"
                      aria-controls={open ? "long-menu" : undefined}
                      aria-expanded={open ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleClick}
                      style={{ padding: 0 }}
                    >
                      <MoreVertOutlinedIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem>
                        <ZoomInOutlinedIcon style={{ marginRight: 5 }} />
                        Atualizar Plano
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      {modalIsOpen ? (
        <ModalCheck
          setModalIsOpen={setModalIsOpen}
          modalIsOpen={modalIsOpen}
          data={data}
        />
      ) : (
        ""
      )}
    </MainLayout>
  )
}

export default Home
